import * as React from "react";
import { Label } from "../../../../components/ui/label";
import { Input } from "../../../../components/ui/input";
import { FieldError } from "../FieldError";

export function InsuredNames({ register }) {
  return (
    <div className="grid gap-4 md:grid-cols-3">
      <div className="space-y-2">
        <Label htmlFor="insuredName">Insured name</Label>
        <Input
          id="insuredName"
          placeholder="Enter..."
          {...register("step2.insuredName")}
        />
        <FieldError name={'step2.insuredName'} step={'step2'} />
        <p className="text-xs text-gray-500">
          Insured name must match FMCSA/SAFER records for filings to be
          processed
        </p>
      </div>
      <div className="space-y-2">
        <Label htmlFor="dba">Doing business as “DBA”</Label>
        <Input id="dba" placeholder="Enter..." {...register("step2.dba")} />
        <FieldError name={"step2.dba"} step={"step2"} />
      </div>
    </div>
  );
}
